import { TinyEmitter } from "tiny-emitter";
import { events } from "../scripts/constants";

declare global {
  interface Window {
    eventEmitter: TinyEmitter;
  }
}

let eventEmitter: TinyEmitter;
if (window.eventEmitter) {
  eventEmitter = window.eventEmitter;
} else {
  eventEmitter = new TinyEmitter();
  window.eventEmitter = eventEmitter;
}

const emit = (event: keyof typeof events, data?: unknown) => {
  const emitter = window.eventEmitter;
  if (!emitter) return;

  emitter.emit(events[event], data);
};

export { emit };

export default eventEmitter;
